<template>
    <div>
        <ion-menu class="hamburger-menu" side="end" type="overlay" content-id="routerView" @ionWillOpen="ionWillOpen">
            <ion-content>
                <ul>
                    <li class="close-button">
                        <img @click="closeHamburger()" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/close-button.png" />
                    </li>
                    <li class="menu-li is-not-login" v-show="!isLogin">
                        <ion-button size="default" fill="outline" @click="goHamburger('/login')">로그인</ion-button>
                        <ion-button size="default" fill="solid" @click="goHamburger('/member/join/step2')">회원가입</ion-button>
                    </li>
                    <li class="menu-li is-login" v-show="isLogin">
                        <div class="member-image">
                            <div>
                                <ion-avatar mode="ios">
                                    <img v-if="member.profile_image_url === '' || member.profile_image_url === null" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/member-image.png">
                                    <img v-else :src="member.profile_image_url">
                                </ion-avatar>
                            </div>
                            <div class="member-image-setting" @click="goHamburger('/mypage/myinfo')">
                                <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/member-image-setting.png" />
                            </div>
                        </div>
                        <div class="member-info">
                            <div class="hello">안녕하세요 !</div>
                            <div class="school" hidden>
                                <span v-if="member.school_div === '10'">초등학교</span>
                                <span v-else-if="member.school_div === '20'">중학교</span>
                                <span>&nbsp;{{ member.school_grade_name }}</span>
                            </div>
                            <div class="nickname">{{ member.nickname }}님</div>
                            <div class="button">
                                <ion-button size="small" fill="outline" @click="goHamburgerLogin('/mypage/ticket')">내 이용권</ion-button>
                                <!--<ion-button size="small" fill="outline" @click="goHamburgerLogin('/mypage/coupon/register')">쿠폰 등록</ion-button>-->
                            </div>
                        </div>
                    </li>
                    <li class="menu-li" @click="isMenuPreview = !isMenuPreview" hidden> 
                        <div class="menu-text">둘러보기</div>
                        <div class="menu-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/menu-preview.png" />
                        </div>
                        <div class="menu-icon">
                            <ion-icon mode="ios" name="arrow-down" v-show="!isMenuPreview"></ion-icon>
                            <ion-icon mode="ios" name="arrow-up" v-show="isMenuPreview"></ion-icon>
                        </div>
                    </li>
                    <li class="sub-menu" v-show="isMenuPreview" hidden>
                        <ul>
                            <li class="school-menu" @click="isMenuElementarySchool = !isMenuElementarySchool">
                                <div>교과동화</div>
                                <div>초등</div>
                                <div>
                                    <ion-icon mode="ios" name="arrow-down" v-show="!isMenuElementarySchool"></ion-icon>
                                    <ion-icon mode="ios" name="arrow-up" v-show="isMenuElementarySchool"></ion-icon>
                                </div>
                            </li>
                            <li class="school-sub-menu is-elementary-school" v-show="isMenuElementarySchool">
                                <div>
                                    <ion-button size="small"  fill="outline" @click="goSchoolPage('10','01')">초 1</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','02')">초 2</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','03')">초 3</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','04')">초 4</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','05')">초 5</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('10','06')">초 6</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('00')">전체</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('10')">국어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('11')">영어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('12')">수학</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('13')">사회</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('14')">과학</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('15')">봄~겨울</ion-button>
                                </div>
                            </li>
                            <li class="school-menu" @click="isMenuMiddleSchool = !isMenuMiddleSchool">
                                <div></div>
                                <div>중등</div>
                                <div>
                                    <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMiddleSchool"></ion-icon>
                                    <ion-icon mode="ios" name="arrow-up" v-show="isMenuMiddleSchool"></ion-icon>
                                </div>
                            </li>
                            <li class="school-sub-menu is-middle-school" v-show="isMenuMiddleSchool">
                                <div>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','01')">중 1</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','02')">중 2</ion-button>
                                    <ion-button size="small" fill="outline" @click="goSchoolPage('20','03')">중 3</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('00')">전체</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('10')">국어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('11')">영어</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('12')">수학</ion-button>
                                </div>
                                <div>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('13')">사회</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('14')">과학</ion-button>
                                    <ion-button size="small" fill="outline" @click="goLecturePage('16')">역사</ion-button>
                                </div>
                            </li>
                            <li @click="goHamburger('/preview/lecture/plan/00')">기획특강</li>
                            <li @click="goHamburger('/preview/teacher')">선생님별</li>
                        </ul>
                    </li>
                    <li class="menu-li" @click="isMenuMyTextbook = !isMenuMyTextbook">
                        <div class="menu-text">내동화</div>
                        <div class="menu-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/menu-mytextbook.png" />
                        </div>
                        <div class="menu-icon">
                            <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyTextbook"></ion-icon>
                            <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyTextbook"></ion-icon>
                        </div>
                    </li>
                    <li class="sub-menu" v-show="isMenuMyTextbook">
                        <ul>
                            <li @click="goHamburgerLogin('/mytextbook/course/listen')">내가 최근에 들은 동화</li>
                            <li @click="goHamburgerLogin('/mytextbook/playlist')">내 플레이 리스트</li>
                            <!-- <li @click="goHamburgerLogin('/mytextbook/course/put')">내가 담은 동화</li> -->
<!--                            <li @click="goHamburgerLogin('/mytextbook/course/download')">내가 다운로드 한 동화</li>-->
                            <!-- <li @click="goHamburgerLogin('/mytextbook/course/interest')">내가 좋아하는 동화</li> -->
                            <!-- <li @click="goHamburgerLogin('/mytextbook/teacher')">내가 좋아하는 선생님</li> -->
                        </ul>
                    </li>
                    <li class="menu-li" @click="isMenuMyContents = !isMenuMyContents">
                        <div class="menu-text">참여하기</div>
                        <div class="menu-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/menu-mycontent.png" />
                        </div>
                        <div class="menu-icon">
                            <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyContents"></ion-icon>
                            <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyContents"></ion-icon>
                        </div>
                    </li>
                    <li class="sub-menu" v-show="isMenuMyContents">
                        <ul>
                            <li @click="goHamburgerLogin('/mycontent/register')">내 동화 만들기</li>
                            <li @click="goHamburgerLogin('/mycontent/mycontent')">내가 참여한 동화</li>
                            <li @click="goHamburger('/mycontent/best')">내가 만든 동화 인기 랭킹</li>
                            <li @click="goHamburger('/mycontent/recommended')">추천해주세요</li>
                        </ul>
                    </li>
                    <li class="menu-li" @click="isMenuMyPage = !isMenuMyPage">
                        <div class="menu-text">My</div>
                        <div class="menu-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/menu-mypage.png" />
                        </div>
                        <div class="menu-icon">
                            <ion-icon mode="ios" name="arrow-down" v-show="!isMenuMyPage"></ion-icon>
                            <ion-icon mode="ios" name="arrow-up" v-show="isMenuMyPage"></ion-icon>
                        </div>
                    </li>
                    <li class="sub-menu" v-show="isMenuMyPage">
                        <ul>
                            <li @click="goHamburger('/mypage/ticket')">이용권 현황</li>
                            <!--<li @click="goHamburgerLogin('/mypage/coupon')">내 쿠폰</li>-->
                            <li @click="goHamburgerLogin('/mypage/myinfo')">내 정보 변경</li>
                            <li @click="goHamburger('/mypage/board')">후기</li>
                            <li @click="goVisitFriend()">친구 초대</li>
                            <!-- <li @click="shareListenNote()">듣는동화 동화노트 공유</li> -->
                            <li @click="goHamburger('/mypage/cs')">고객센터</li>
                        </ul>
                    </li>
                    <li class="menu-li" @click="goHamburgerLogin('/mypage/setting')">
                        <div class="menu-text">설정</div>
                        <div class="menu-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/hamburger-menu/menu-setting.png" />
                        </div>
                    </li>
                </ul>
            </ion-content>
        </ion-menu>
        <ion-menu-controller id="routerView"></ion-menu-controller>
    </div>
</template>

<script>
    import * as ajax from "../utils/ajax";
    import * as alert from '../utils/alert';
    import * as biz from "../utils/biz";
    import * as utils from "../utils/utils";

    export default {
        name: "Hamburger",
        data() {
            return {
                isLogin: false,
                isMenuPreview: false,
                isMenuMyTextbook: false,
                isMenuMyContents: false,
                isMenuMyPage: false,
                isMenuElementarySchool: false,
                isMenuMiddleSchool: false,
                member: {
                    nickname: null,
                    profile_image_url: null,
                    school_div: null,
                    school_grade: null,
                    school_grade_name: null
                }
            }
        },
        mounted() {
        },
        methods: {
            ionWillOpen() {
                this.isLogin = biz.isLogin(this);
                if (this.isLogin) {
                   this.getMemberInfo();
                }
                this.isMenuPreview = false;
                this.isMenuMyTextbook = false;
                this.isMenuMyContents = false;
                this.isMenuMyPage = false;
                this.isMenuElementarySchool = false;
                this.isMenuMiddleSchool = false;
            },
            getMemberInfo() {
                ajax.Get(this, "/api/member/member/", function(ref, data) {
                    if (data.nickname === null || data.nickname === "")
                        data.nickname = data.member_name;

                    ref.member.nickname = data.nickname;
                    ref.member.profile_image_url = data.profile_image_url;
                    ref.member.school_div = data.school_div;
                    ref.member.school_grade = data.school_grade;
                    ref.member.school_grade_name = data.school_grade_name;
                });
            },
            openHamburger() {
                document.querySelector('ion-menu-controller').open();
            },
            closeHamburger() {
                document.querySelector('ion-menu-controller').close();
            },
            goHamburger(url) {
                this.$router.push(url);
                document.querySelector('ion-menu-controller').close();
            },
            goHamburgerLogin(url) {
                if (!this.isLogin) {
                    alert.alertLogin(this);
                } else {
                    this.$router.push(url);
                }
                document.querySelector('ion-menu-controller').close();
            },
            goSchoolPage(school, grade) {
                this.$cookie.set("tempSchoolDiv", school);
                this.$cookie.set("tempSchoolGrade", grade);

                const today = new Date();
                this.$router.push({path: '/preview/lecture/subject/00', query: { key: today.toISOString() }});

                document.querySelector('ion-menu-controller').close();
            },
            goLecturePage(subject) {
                const today = new Date();
                this.$router.push({path: '/preview/lecture/subject/' + subject, query: { key: today.toISOString() }});

                document.querySelector('ion-menu-controller').close();
            },
            goVisitFriend() {
                if (!this.isLogin) {
                    alert.alertLogin(this);
                } else {
                    const message = this.member.member_name + "님이 듣는동화로 당신을 초대했어요!\n" +
                        "부담없이 들을 수 있는 교과서, 친구와 함께 들어봐요~\n" +
                        "http://textbooklistening.com";

                    switch(utils.deviceInfo()) {
                        case "Android":
                            window.listenApp.invokeShare(message);
                            break;
                        case "iOS":
                            window.webkit.messageHandlers.invokeShare.postMessage(message);
                            break;
                    }
                }
            },
          shareListenNote() {
            if (!this.isLogin) {
              alert.alertLogin(this);
            } else {
              const message = "듣는동화 전용 '필기노트'를 이용하여 학습에 활용해 보세요~\n" +
                  "https://ba8hb5guu4.ecn.cdn.ofs.kr/doc/listen_note.pdf";

              switch(utils.deviceInfo()) {
                case "Android":
                  window.listenApp.invokeShare(message);
                  break;
                case "iOS":
                  window.webkit.messageHandlers.invokeShare.postMessage(message);
                  break;
              }
            }
          },
        }
    }
</script>

<style scoped lang="scss">
    ul {
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;

        li.menu-li {
            width: 100%;
            height: 50px;
            margin: 0 0 1px 0;
            padding: 0 10px;
            display: flex;
            justify-content: space-between;
            background-color: $line-third-color;
            line-height: 50px;
            font-weight: 500;

            &:last-child {
                background-color: #ffffff;
            }
            div.menu-text {
                width: 80px;
            }
            div.menu-image {
                flex: 1;
                img {
                    height: 18px;
                    vertical-align: sub;
                }
            }
            div.menu-icon {
                width: 16px;
                color: $font-fourth-color;

                ion-icon[name=arrow-up] {
                    color: #ff6c00;
                }
            }
        }
        li.close-button {
            height: 18px;
            padding: 10px 10px 0 10px;
            text-align: right;

            img {
                height: 18px;
            }
        }
        li.is-not-login {
            height: 135px;
            padding: 40px 40px;
            background-color: #ffffff;

            ion-button {
                width: 91px;
            }
        }
        li.is-login {
            height: 135px;
            padding: 10px 10px 0 10px;
            display: flex;
            justify-content: center;
            background-color: #ffffff;

            div.member-image {
                margin: 0 20px 0 0;
                padding: 20px 0 0 0;
                text-align: center;

                div.member-image-setting {
                    img {
                        height: 20px;
                        vertical-align: super;
                    }
                }
            }
            div.member-info {
                text-align: center;

                div.hello {
                    height: 20px;
                    margin: 0 0 5px 0;
                    line-height: 20px;
                    font-size: $font-base12;
                    color: $font-third-color;
                }
                div.school {
                    height: 20px;
                    line-height: 20px;
                    color: $font-third-color;
                }
                div.nickname {
                    height: 20px;
                    line-height: 20px;
                }
                div.button {
                    height: 52px;

                    ion-button {
                        width: 66px;
                        height: 26px;
                        color: $font-third-color;
                        --border-color: #666668;
                        --color-activated: none;
                        --color-focused: none;
                        --color-hover: none;
                        --background-activated: none;
                        --background-focused: none;
                        --background-hover: none;
                    }
                }
            }
        }
        li.sub-menu {
            background-color: #ffffff;

            & > ul {
                li {
                    width: 100%;
                    height: 40px;
                    margin: 0;
                    padding: 0 15px;
                    border-bottom: 1px solid $line-third-color;
                    line-height: 40px;
                    font-size: $font-base14;
                    font-weight: 400;
                    color: $font-third-color;
                }
                li.school-menu {
                    display: flex;
                    justify-content: flex-start;

                    div {
                        ion-icon[name=arrow-down] {
                            color: $line-secondary-color;
                        }
                        ion-icon[name=arrow-up] {
                            color: #ff6c00;
                        }
                    }
                    div:nth-child(1) {
                        width: 75px;
                    }
                    div:nth-child(2) {
                        width: 40px;
                    }
                }
                li.school-sub-menu {
                    height: auto;
                    text-align: right;

                    & > div {
                        height: 32px;
                    }

                    ion-button {
                        width: 62px;
                        color: $font-third-color;
                        --border-color: #d4d4d4;
                        --color-activated: none;
                        --color-focused: none;
                        --color-hover: none;
                        --background-activated: none;
                        --background-focused: none;
                        --background-hover: none;
                    }
                }
                li.school-sub-menu.is-elementary-school {
                    height: 148px;
                }
                li.school-sub-menu.is-middle-school {
                    height: 118px;
                }
            }
        }
    }
</style>